import gql from 'graphql-tag';

export const getAllEquipmentQuery = gql(/* GraphQL */ `
  query getAllEquipment($channelId: UUID!, $includeArchived: Boolean) {
    getAllEquipment(channelId: $channelId, includeArchived: $includeArchived) {
      id
      name
      category
      location
      status
      notes
      attachments
      createdBy
      createdAt
      updatedAt
      updatedBy
      isArchived
      channelId
      make
      model
      asset
      serial
      floor
      suite
      installDate
      warrantyExpirationDate
      hyperlinks {
        name
        url
      }
      meterReadingSettings {
        id
        unit
        name
        enableNotification
        notificationTrigger
        upperBound
        lowerBound
        notificationTypes
        equipmentId
      }
    }
  }
`);
